<!--
 * @Author:
 * @Description:步骤1-公司详情
 * @Date: 2024-09-09 14:11:44
 * @LastEditors: Please set LastEditors
 * @FilePath: /rhcn-merchant-web/src/views/register/networkApplication/components/step-companyDetails.vue
-->
<template>
  <div class="step_companyType" v-loading="loading">
    <div>
      <p class="descript1"> {{ $t('message.register.validateBusiness.companyDetails.descript1') }}</p>
      <p class="descript2">{{ $t('message.register.validateBusiness.companyDetails.descript2') }}</p>
    </div>
    <validation-component ref="validationForm" :validation-condition="validationCondition">
      <template slot="companyRegistrationDate">
        <RhcnDatepicker v-model="form.companyRegistrationDate" :pickerOptions="pickerStartOptions" type="date"
          :format="'yyyy-MM-dd'" :disabled="isDisabled">
        </RhcnDatepicker>
      </template>
      <!-- 公司注册证书 -->
      <div slot="certificateOfIncorporation">
        <template>
          <RhcnUpload :title="$t('message.register.businessDetails.certificate_of_incorporation')"
            :fileList="form.uploadCompanyCertificates.fileList.certificateOfIncorporation"
            :on-change="onMaterialItemChange('form', 'uploadCompanyCertificates', 'certificateOfIncorporation')"
            :on-remove="onMaterialItemRemove('form', 'uploadCompanyCertificates', 'certificateOfIncorporation')"
            :disabled="isDisabled">
          </RhcnUpload>
        </template>
      </div>
      <!-- 公司营业登记证书 -->
      <div slot="businessRegistrationCertificate">
        <template>
          <RhcnUpload :title="$t('message.register.businessDetails.business_registration_certificate')"
            :fileList="form.uploadCompanyCertificates.fileList.businessRegistrationCertificate"
            :on-change="onMaterialItemChange('form', 'uploadCompanyCertificates', 'businessRegistrationCertificate')"
            :on-remove="onMaterialItemRemove('form', 'uploadCompanyCertificates', 'businessRegistrationCertificate')"
            :disabled="isDisabled">
          </RhcnUpload>
        </template>
      </div>
      <!-- 公司NNC1/NAR1 -->
      <div slot="companyNnc1OrNar1">
        <template>
          <RhcnUpload :title="$t('message.register.businessDetails.company_NNC1/NAR1')"
            :fileList="form.uploadCompanyCertificates.fileList.companyNnc1OrNar1"
            :on-change="onMaterialItemChange('form', 'uploadCompanyCertificates', 'companyNnc1OrNar1')"
            :on-remove="onMaterialItemRemove('form', 'uploadCompanyCertificates', 'companyNnc1OrNar1')"
            :disabled="isDisabled">
          </RhcnUpload>
        </template>
      </div>
      <!-- 股权结构说明 -->
      <div slot="explanationOfShareholdingStructure">
        <template>
          <RhcnUpload :title="$t('message.register.businessDetails.explanation_of_shareholding_structure')"
            :fileList="form.uploadCompanyCertificates.fileList.explanationOfShareholdingStructure"
            :on-change="onMaterialItemChange('form', 'uploadCompanyCertificates', 'explanationOfShareholdingStructure')"
            :on-remove="onMaterialItemRemove('form', 'uploadCompanyCertificates', 'explanationOfShareholdingStructure')"
            :disabled="isDisabled">
          </RhcnUpload>
        </template>
      </div>
      <!-- 公司章程 -->
      <div slot="articlesOfAssociation">
        <template>
          <RhcnUpload :title="$t('message.register.businessDetails.articles_of_association')"
            :fileList="form.uploadCompanyCertificates.fileList.articlesOfAssociation"
            :on-change="onMaterialItemChange('form', 'uploadCompanyCertificates', 'articlesOfAssociation')"
            :on-remove="onMaterialItemRemove('form', 'uploadCompanyCertificates', 'articlesOfAssociation')"
            :disabled="isDisabled">
          </RhcnUpload>
        </template>
      </div>
      <div slot="extraDocument1">
        <template>
          <RhcnUpload :title="$t('message.register.businessDetails.extra_document_1')"
            :fileList="form.uploadCompanyCertificates.fileList.extraDocument1"
            :on-change="onMaterialItemChange('form', 'uploadCompanyCertificates', 'extraDocument1')"
            :on-remove="onMaterialItemRemove('form', 'uploadCompanyCertificates', 'extraDocument1')"
            :disabled="isDisabled">
          </RhcnUpload>
        </template>
      </div>
      <div slot="extraDocument2">
        <template>
          <RhcnUpload :title="$t('message.register.businessDetails.extra_document_2')"
            :fileList="form.uploadCompanyCertificates.fileList.extraDocument2"
            :on-change="onMaterialItemChange('form', 'uploadCompanyCertificates', 'extraDocument2')"
            :on-remove="onMaterialItemRemove('form', 'uploadCompanyCertificates', 'extraDocument2')"
            :disabled="isDisabled">
          </RhcnUpload>
        </template>
      </div>
      <div slot="extraDocument3">
        <template>
          <RhcnUpload :title="$t('message.register.businessDetails.extra_document_3')"
            :fileList="form.uploadCompanyCertificates.fileList.extraDocument3"
            :on-change="onMaterialItemChange('form', 'uploadCompanyCertificates', 'extraDocument3')"
            :on-remove="onMaterialItemRemove('form', 'uploadCompanyCertificates', 'extraDocument3')"
            :disabled="isDisabled">
          </RhcnUpload>
        </template>
      </div>
    </validation-component>
    <div class="button-box">
      <el-button type="primary" @click="confirm" size="medium" :disabled="isDisabled">{{ $t('message.exchange.continue')
        }}</el-button>
    </div>
  </div>
</template>

<script>

import moment from 'moment';

import RhcnDatepicker from '@/components/form/datepicker.vue';
import { REQUIRED } from '@/components/validation/tool/validator';
import ValidationComponent from '@/components/validation/validation.vue';
import { businessLocation } from '@/utils/options/networkApplication';
import RhcnUpload from '@/views/account/information/supplement/upload/index.vue';

import mixins from '../../mixins';
export default {
  name: 'StepCompanyDetails',
  components: {
    ValidationComponent,
    RhcnDatepicker,
    RhcnUpload,
  },
  mixins: [mixins],
  data() {
    return {
      form: {
        businessLocation: '',
        typeOfBusiness: '',
        companyRegistrationDate: new Date(),
        uploadCompanyCertificates: {
          certificateOfIncorporation: '', // 公司注册证书
          businessRegistrationCertificate: '', // 公司营业登记证书
          companyNnc1OrNar1: '', // 公司NNC1/NAR1
          explanationOfShareholdingStructure: '', // 股权结构说明
          articlesOfAssociation: '', // 公司章程
          extraDocument1: '', // 补充资料1
          extraDocument2: '', // 补充资料2
          extraDocument3: '', // 补充资料3
          fileList: {
            certificateOfIncorporation: [],
            businessRegistrationCertificate: [], // 公司营业登记证书
            companyNnc1OrNar1: [], // 公司NNC1/NAR1
            explanationOfShareholdingStructure: [], // 股权结构说明
            articlesOfAssociation: [], // 公司章程
            extraDocument1: [], // 补充资料1
            extraDocument2: [], // 补充资料2
            extraDocument3: [], // 补充资料3
          },
        },
      },
      validationCondition: [
        // 法定公司名称
        {
          key: 'legalBusinessName',
          name: 'message.register.businessDetails.legal_business_name',
          type: 'input',
          defValue: '',
          placeholder: 'message.register.businessDetails.legal_business_name_input_placeHolder',
          options: businessLocation,
          isInternationalization: true,
          isShowStar: true,
          rule: [REQUIRED],
          validator: (rule, value, callback) => {
            const regex = /^[\u4e00-\u9fff\u3400-\u4dbf\u2e80-\u2eff\u3000-\u303f\uff00-\uffef\w\s.,!?;:'"()\-/]+$/;

            if (!regex.test(value)) {
              callback(new Error(this.$t('message.register.errorTitle.input')));
              //   return;
            } else {
              callback();
            }
          },
        },
        // 公司注册号码
        {
          key: 'companyRegistrationNumber',
          name: 'message.register.businessDetails.company_registration_number',
          type: 'input',
          defValue: '',
          isInternationalization: true,
          options: [],
          isShowStar: true,
          rule: [REQUIRED],
        },
        // 公司注册日期
        {
          key: 'companyRegistrationDate',
          name: 'message.register.businessDetails.company_registration_date',
          type: 'slot',
          placeholder: 'message.register.businessTypeTips',
          options: businessLocation,
          isInternationalization: true,
          isShowStar: true,
        },
        // 公司营业名称
        {
          key: 'businessName',
          name: 'message.register.businessDetails.business_name',
          type: 'input',
          defValue: '',
          isInternationalization: true,
          options: [],
          isShowStar: true,
          rule: [REQUIRED],
        },
        // 公司注册地址
        {
          key: 'location', // 所在地
          name: 'message.register.businessDetails.registered_business_address',
          type: 'select',
          defValue: this.$attrs.formData.businessType.businessLocation || 'Hong Kong SAR China',
          placeholder: 'message.register.businessTypeTips',
          isInternationalization: true,
          options: businessLocation,
          isDisabled: true,
          isShowStar: true,
          rule: [REQUIRED],
          validator: (rule, value, callback) => {
            const regex = /^[\u4e00-\u9fff\u3400-\u4dbf\u2e80-\u2eff\u3000-\u303f\uff00-\uffef\w\s.,!?;:'"()\-/]+$/;

            if (!regex.test(value)) {
              callback(new Error(this.$t('message.register.errorTitle.input')));
              //   return;
            } else {
              callback();
            }
          },
        },
        {
          key: 'areaOrCity', // 城市/区域
          type: 'input',
          defValue: '',
          placeholder: 'message.register.businessDetails.location',
          isInternationalization: true,
          isShowStar: true,
          rule: [REQUIRED],
          validator: (rule, value, callback) => {
            const regex = /^[\u4e00-\u9fff\u3400-\u4dbf\u2e80-\u2eff\u3000-\u303f\uff00-\uffef\w\s.,!?;:'"()\-/]+$/;

            if (!regex.test(value)) {
              callback(new Error(this.$t('message.register.errorTitle.input')));
              //   return;
            } else {
              callback();
            }
          },
        },
        {
          key: 'district', // 地区
          type: 'input',
          defValue: '',
          placeholder: 'message.register.businessDetails.district',
          isInternationalization: true,
          isShowStar: true,
          rule: [REQUIRED],
          validator: (rule, value, callback) => {
            const regex = /^[\u4e00-\u9fff\u3400-\u4dbf\u2e80-\u2eff\u3000-\u303f\uff00-\uffef\w\s.,!?;:'"()\-/]+$/;

            if (!regex.test(value)) {
              callback(new Error(this.$t('message.register.errorTitle.input')));
              //   return;
            } else {
              callback();
            }
          },
        },
        {
          key: 'addressLine1', // 城市/区域
          type: 'input',
          defValue: '',
          placeholder: 'message.register.businessDetails.address_line_1',
          isInternationalization: true,
          options: businessLocation,
          isShowStar: true,
          rule: [REQUIRED],
          validator: (rule, value, callback) => {
            const regex = /^[\u4e00-\u9fff\u3400-\u4dbf\u2e80-\u2eff\u3000-\u303f\uff00-\uffef\w\s.,!?;:'"()\-/]+$/;

            if (!regex.test(value)) {
              callback(new Error(this.$t('message.register.errorTitle.input')));
              //   return;
            } else {
              callback();
            }
          },
        },
        {
          key: 'addressLine2',
          type: 'input',
          defValue: '',
          placeholder: 'message.register.businessDetails.address_line_2',
          isInternationalization: true,
          isShowStar: true,
          rule: [],
          validator: (rule, value, callback) => {
            if ((!value || value.trim() === '') && value !== '0') {
              callback();
            }
            const regex = /^[\u4e00-\u9fff\u3400-\u4dbf\u2e80-\u2eff\u3000-\u303f\uff00-\uffef\w\s.,!?;:'"()\-/]+$/;
            if (!regex.test(value)) {
              callback(new Error(this.$t('message.register.errorTitle.input')));
              //   return;
            } else {
              callback();
            }
          },
        },
        {
          key: 'postalCode',
          type: 'input',
          defValue: '',
          placeholder: 'message.register.businessDetails.postal_code',
          isInternationalization: true,
          isShowStar: true,
          rule: [REQUIRED],
          validator: (rule, value, callback) => {
            const regex = /^[\u4e00-\u9fff\u3400-\u4dbf\u2e80-\u2eff\u3000-\u303f\uff00-\uffef\w\s.,!?;:'"()\-/]+$/;

            if (!regex.test(value)) {
              callback(new Error(this.$t('message.register.errorTitle.input')));
              //   return;
            } else {
              callback();
            }
          },
        },
        // 公司号码
        {
          key: 'businessPhoneNumber',
          name: 'message.register.businessDetails.business_phone_number',
          type: 'input',
          defValue: '',
          isInternationalization: true,
          isShowStar: true,
          rule: [REQUIRED],
          validator: (rule, value, callback) => {
            const regex = /^[\u4e00-\u9fff\u3400-\u4dbf\u2e80-\u2eff\u3000-\u303f\uff00-\uffef\w\s.,!?;:'"()\-/]+$/;

            if (!regex.test(value)) {
              callback(new Error(this.$t('message.register.errorTitle.input')));
              //   return;
            } else {
              callback();
            }
          },
        },
        // 上传公司资料
        {
          key: 'certificateOfIncorporation', // 公司注册证书
          name: 'message.register.businessDetails.upload_company_certificates',
          description: 'message.register.businessDetails.upload_limit',
          type: 'slot',
          defValue: '',
          isInternationalization: true,
          isShowStar: true,
          rule: [REQUIRED],
        },
        {
          key: 'businessRegistrationCertificate', // 公司营业登记证书
          type: 'slot',
          defValue: '',
          isInternationalization: true,
          isShowStar: true,
          rule: [REQUIRED],
        },
        {
          key: 'companyNnc1OrNar1', // 公司NNC1/NAR1
          type: 'slot',
          defValue: '',
          isInternationalization: true,
          isShowStar: true,
          rule: [REQUIRED],

        },
        {
          key: 'explanationOfShareholdingStructure', // 股权结构说明
          type: 'slot',
          defValue: '',
          isInternationalization: true,
          isShowStar: true,
          rule: [REQUIRED],

        },
        {
          key: 'articlesOfAssociation', // 公司章程
          type: 'slot',
          defValue: '',
          isInternationalization: true,
          isShowStar: true,
          rule: [REQUIRED],
        },
        {
          key: 'extraDocument1', // 补充资料1
          type: 'slot',
          defValue: '',
          isInternationalization: true,
          isShowStar: true,
        },
        {
          key: 'extraDocument2', // 补充资料2
          type: 'slot',
          defValue: '',
          isInternationalization: true,
          isShowStar: true,
        },
        {
          key: 'extraDocument3', // 补充资料3
          type: 'slot',
          defValue: '',
          isInternationalization: true,
          isShowStar: true,
        },

      ],
      pickerStartOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  mounted() {
    const { businessLocation } = this.$attrs.formData.businessType;
    switch (businessLocation) {
      case 'Hong Kong SAR China':
        this.$refs.validationForm.setItemHide('explanationOfShareholdingStructure', true);
        this.$refs.validationForm.setItemHide('articlesOfAssociation', true);
        break;
      case 'United Kingdom':
        this.$refs.validationForm.setItemHide('businessRegistrationCertificate', true);
        this.$refs.validationForm.setItemHide('companyNnc1OrNar1', true);
        break;
    }
  },
  methods: {
    confirm() {
      this.$refs.validationForm.toFormValid(data => {
        const {
          legalBusinessName,
          companyRegistrationNumber,
          businessName,
          businessPhoneNumber,
          location,
          areaOrCity,
          district,
          addressLine1,
          addressLine2,
          postalCode,
        } = data;
        const {
          companyRegistrationDate, uploadCompanyCertificates: {
            fileList: {
              certificateOfIncorporation,
              businessRegistrationCertificate,
              companyNnc1OrNar1,
              explanationOfShareholdingStructure,
              articlesOfAssociation,
              extraDocument1,
              extraDocument2,
              extraDocument3,
            },
          },
        } = this.form;

        const businessDetails = {
          legalBusinessName,
          companyRegistrationNumber,
          companyRegistrationDate: moment(companyRegistrationDate).format('YYYY-MM-DD'),
          businessName,
          businessPhoneNumber,
          registeredBusinessAddress: {
            location,
            areaOrCity,
            district,
            addressLine1,
            addressLine2,
            postalCode,
          },
          uploadCompanyCertificates: {
            certificateOfIncorporation: certificateOfIncorporation.length ? certificateOfIncorporation[0].url : '', // 公司注册证书
            businessRegistrationCertificate: businessRegistrationCertificate.length ? businessRegistrationCertificate[0].url : '', // 公司营业登记证书
            companyNnc1OrNar1: companyNnc1OrNar1.length ? companyNnc1OrNar1[0].url : '', // 公司NNC1/NAR1
            explanationOfShareholdingStructure: explanationOfShareholdingStructure.length ? explanationOfShareholdingStructure[0].url : '', // 股权结构说明
            articlesOfAssociation: articlesOfAssociation.length ? articlesOfAssociation[0].url : '', // 公司章程
            extraDocument1: extraDocument1.length ? extraDocument1[0].url : '', // 补充资料1
            extraDocument2: extraDocument2.length ? extraDocument2[0].url : '', // 补充资料2
            extraDocument3: extraDocument3.length ? extraDocument3[0].url : '', // 补充资料3
          },
        };
        this.$emit('updateFormData', { businessDetails, currentStep: 'businessDetails', nextStep: 'businessRepresentative' });
      });
    },
  },
  watch: {
    applicationInfo: {
      handler(applicationInfo) {
        const {
          businessDetails, businessDetails: { registeredBusinessAddress, uploadCompanyCertificates, legalBusinessName, companyRegistrationDate }, currentStep,
        } = applicationInfo;
        const _data = { ...businessDetails, ...registeredBusinessAddress, ...uploadCompanyCertificates };
        const isDisabled = currentStep === 'status';
        if (isDisabled) {
          this.$refs.validationForm.setItemDisabled('', true, true);
        }
        if (legalBusinessName) {
          [
            'legalBusinessName',
            'companyRegistrationNumber',
            'businessName',
            'companyRegistrationDate',
            'businessPhoneNumber',
            'location',
            'areaOrCity',
            'district',
            'addressLine1',
            'addressLine2',
            'postalCode',
            'certificateOfIncorporation',
            'businessRegistrationCertificate',
            'companyNnc1OrNar1',
            'explanationOfShareholdingStructure',
            'articlesOfAssociation',
            'extraDocument1',
            'extraDocument2',
            'extraDocument3'].forEach(key => {
              this.form.companyRegistrationDate = moment(companyRegistrationDate);
              this.$refs.validationForm.setItemValue(key, _data[key] || '');
            });
          const arr = [
            'certificateOfIncorporation',
            'businessRegistrationCertificate',
            'companyNnc1OrNar1',
            'explanationOfShareholdingStructure',
            'articlesOfAssociation',
            'extraDocument1',
            'extraDocument2',
            'extraDocument3'];
          arr.forEach(item => {
            this.form.uploadCompanyCertificates[item] = _data[item];
            _data[item] && this.form.uploadCompanyCertificates.fileList[item].push({
              url: _data[item],
              name: '',
            });
          });
          this.$nextTick(() => {
            this.$refs.validationForm.toFormValid(data => {
              const {
                legalBusinessName,
                companyRegistrationNumber,
                businessName,
                businessPhoneNumber,
                location,
                areaOrCity,
                district,
                addressLine1,
                addressLine2,
                postalCode,
              } = data;
              const {
                companyRegistrationDate, uploadCompanyCertificates: {
                  fileList: {
                    certificateOfIncorporation,
                    businessRegistrationCertificate,
                    companyNnc1OrNar1,
                    explanationOfShareholdingStructure,
                    articlesOfAssociation,
                    extraDocument1,
                    extraDocument2,
                    extraDocument3,
                  },
                },
              } = this.form;

              const businessDetails = {
                legalBusinessName,
                companyRegistrationNumber,
                companyRegistrationDate: moment(companyRegistrationDate).format('YYYY-MM-DD'),
                businessName,
                businessPhoneNumber,
                registeredBusinessAddress: {
                  location,
                  areaOrCity,
                  district,
                  addressLine1,
                  addressLine2,
                  postalCode,
                },
                uploadCompanyCertificates: {
                  certificateOfIncorporation: certificateOfIncorporation.length ? certificateOfIncorporation[0].url : '', // 公司注册证书
                  businessRegistrationCertificate: businessRegistrationCertificate.length ? businessRegistrationCertificate[0].url : '', // 公司营业登记证书
                  companyNnc1OrNar1: companyNnc1OrNar1.length ? companyNnc1OrNar1[0].url : '', // 公司NNC1/NAR1
                  explanationOfShareholdingStructure: explanationOfShareholdingStructure.length ? explanationOfShareholdingStructure[0].url : '', // 股权结构说明
                  articlesOfAssociation: articlesOfAssociation.length ? articlesOfAssociation[0].url : '', // 公司章程
                  extraDocument1: extraDocument1.length ? extraDocument1[0].url : '', // 补充资料1
                  extraDocument2: extraDocument2.length ? extraDocument2[0].url : '', // 补充资料2
                  extraDocument3: extraDocument3.length ? extraDocument3[0].url : '', // 补充资料3
                },
              };
              this.$emit('onlyUpdateForm', { businessDetails, currentStep: 'businessDetails' });
            });
          });
        }
      },
      deep: true,
    },
  },

};
</script>

<style scoped lang="scss">
.button-box {
  width: 100%;

  .el-button {
    width: 100% !important;
  }
}
</style>
